<template>
  <div style="z-index: 1">
    <img v-if="src" :src="'svg/' + src" :width="width" :height="height" />
  </div>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "drawing",
  mixins: [MixinStates],
  props: {
    src: {
      type: String,
      required: true,
      default: "",
    },
  },
  methods: {
    svgLoaded() {},
    /* Load an SVG file with XHR and generate an inline SVG code */
    generateInlineSVG() {
      const context = this;

      // Reset first. Remove all the code of the existing inline SVG
      // this.resetInlineSVG()

      // Get the content of the SVG file
      const request = new XMLHttpRequest();
      request.open("GET", this.src, true);
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          // Setup a DOM parser to convert the response to text/xml
          const domParser = new DOMParser();
          const result = domParser.parseFromString(request.responseText, "text/xml");
          const loadedSVG = result.getElementsByTagName("svg")[0];

          if (!loadedSVG) {
            console.error("No SVG element found in the given file: " + context.filepath);
            return;
          }
          context.$el.appendChild(loadedSVG);
          context.$emit("load");
        } else {
          console.error("There was an error retrieving the source of the SVG.");
        }
      };

      request.onerror = function () {
        console.error("There was on XML Http Request");
      };

      request.send();
    },
    resetInlineSVG() {
      while (this.$el.firstChild) {
        this.$el.removeChild(this.$el.firstChild);
      }
      const attributeNames = this.$el.getAttributeNames();
      for (const name of attributeNames) {
        this.$el.removeAttribute(name);
      }
    },
  },
  mounted() {
    //this.generateInlineSVG()
  },
  watch: {
    /* src () {
     
      this.generateInlineSVG()
    },*/
  },
};
</script>
